import * as bus from "@sinch/bus";
import { clearLocalStorage } from "./helpers/localStorage/localStorage";
import { clearSessionStorage } from "./helpers/sessionStorage";

const unsub = bus.listen((message) => {
  if (bus.isData(message)) {
    if (message.payload.clearOnly !== "local") {
      clearSessionStorage(message.payload.ignoreKeys ?? []);
    }
    if (message.payload.clearOnly !== "session") {
      clearLocalStorage(message.payload.ignoreKeys ?? []);
    }
  }
}, bus.isClearStorageMessage);

window.addEventListener("unload", unsub);
